module.exports = __webpack_public_path__ + "static/img/a4.de548aa8.jpg";